import { GetterTree } from "vuex";
import { AppState } from "@/store/mainStore/state";
import { RootState } from "@/store/root.state";
import PageContext from "@/entities/page.context";
import { Modal } from "@/entities/modal";

export const getters: GetterTree<AppState, RootState> = {
  pageContext(state: AppState): PageContext {
    return state.pageContext;
  },
  isMobileView(state: AppState): boolean {
    return state.isMobileView;
  }, 
  modal(state: AppState): Modal {
    return state.modal;
  },
  messages(state: AppState): Map<string, string> {
    return state.messages;
  },
  marketResult(state: AppState): Map<string, {answer: string, eventId:string, marketId: string, isSubmited: boolean, submitedAns: string}> {
    return state.marketResult;
  },
}